import React from 'react';
import PropTypes from 'prop-types';
import conditions from './conditionTypes.json';
import CustomRadioInput from './CustomRadioInput';
/**
 * Component which can be used to select book-conditions.
 * The different conditions are loaded from a json file.
 * */
var ConditionSelectField = function (props) {
    var fieldName = props.fieldName, _a = props.currentCondition, currentCondition = _a === void 0 ? null : _a, onBlur = props.onBlur, onChange = props.onChange, _b = props.required, required = _b === void 0 ? false : _b;
    return React.createElement("div", { className: "bookcondition" }, conditions.map(function (condition, key) { return React.createElement(CustomRadioInput, { key: "condition-" + key, name: fieldName, inputLabel: condition.label, inputValue: condition.value, hint: condition.hint, onBlur: onBlur, onChange: onChange, isChecked: condition.value === currentCondition, required: required }); }));
};
ConditionSelectField.propTypes = {
    fieldName: PropTypes.string.isRequired,
    required: PropTypes.bool,
    currentCondition: PropTypes.any,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};
export default ConditionSelectField;
